module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-product-card', {
    attrs: {
      "product": _vm.product,
      "image": _vm.image,
      "to": {
        path: ("/ecommerce/moovin/products/" + (_vm.product.productId))
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c6290e7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductProvide/List/Card/Moovin.vue
// module id = 3071
// module chunks = 0